import {Component, OnInit} from '@angular/core';
import {NavigationEnd, Router} from '@angular/router';
import {UntypedFormBuilder} from '@angular/forms';
import {LoginService} from '../../../core/login/login.service';
import {JhiEventManager} from '../../../Services/event-manager.service';
import {AccountService} from '../../../core/auth/account.service';

@Component({
  selector: 'app-header-one',
  templateUrl: './HeaderOne.component.html',
  styleUrls: ['./HeaderOne.component.scss']
})
export class HeaderOneComponent implements OnInit {


  emailPattern = '^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$';

  currentUrl: any;
  isNavbarCollapsed: boolean;

  constructor(
    private fb: UntypedFormBuilder,
    private loginService: LoginService,
    private eventManager: JhiEventManager,
    private accountService: AccountService,
    private router: Router) {
  }

  ngOnInit() {
    this.currentUrl = this.router.url;
    // classes add or remove on header section.
    this.router.events
      .subscribe((event) => {
        if (event instanceof NavigationEnd) {
          this.currentUrl = event.url;
          if ((this.currentUrl !== '/session/comingsoon') && (this.currentUrl !== '/session/maintenance') && (this.currentUrl !== '/session/login') && (this.currentUrl !== '/session/signup2')) {
            document.documentElement.classList.remove('resp-menu-opened');
            document.getElementById('main-header').classList.remove('show');
            if (this.currentUrl === '/home') {
              document.getElementById('header-sec').className += ' header-transparent';
            } else {
              document.getElementById('header-sec').classList.remove('header-transparent');
            }
          } else {
            document.documentElement.classList.remove('resp-menu-opened');
          }

        }
      });

    // header responsive
    if ((this.currentUrl !== '/session/comingsoon') && (this.currentUrl !== '/session/maintenance') && (this.currentUrl !== '/session/login') && (this.currentUrl !== '/session/signup2')) {
      const navbar = document.getElementsByClassName('navbar-toggler');
      for (let i = 0; i < navbar.length; i++) {
        (function (index) {
          navbar[index].addEventListener('click', function (event) {
            document.documentElement.classList.toggle('resp-menu-opened');
          });
        })(i);
      }
    }

  }


  login() {
    this.eventManager.broadcast({
      name: 'triggerAuthentication',
      content: 'Requesting Authentication'
    });

  }

  collapseNavbar() {
    this.isNavbarCollapsed = true;
  }


  logout() {
    this.collapseNavbar();
    this.loginService.logout();
    this.router.navigate(['']);
  }

  toggleNavbar() {
    this.isNavbarCollapsed = !this.isNavbarCollapsed;
  }

  getImageUrl() {
    return this.isAuthenticated() ? this.accountService.getImageUrl() : null;
  }

  isAuthenticated() {
    return this.accountService.isAuthenticated();
  }
}
